import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { loginUser } from "../features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { theme } from "../utils/theme";

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  h2 {
    text-align: center;
  }
`;

const Form = styled.form`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 30%;
  margin: auto;
  gap: 1rem;

  @media (max-width: 600px) {
    width: 80%;
  }

  // Tablets
  @media only screen and (min-width: 768px) {
    width: 70%;
  }

  // Laptops & Desktops
  @media only screen and (min-width: 992px) {
    width: 30%;
  }
`;

const Input = styled.input`
  padding: 0.7rem;
  border: 2px solid #808080c9;
`;

const Button = styled.button`
  background-color: ${theme.colors.primary};
  border: none;
  color: white;
  padding: 0.7rem;
  text-decoration: none;
  cursor: pointer;
`;

const LoginScreen = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, isLoading, isError, isSuccess, message } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (isError) {
      toast.error(message.message);
    }

    if (isSuccess || user) {
      navigate("/");
    }

    // dispatch(reset())
  }, [user, isError, isSuccess, message, navigate]);

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const userData = {
      email,
      password,
    };

    dispatch(loginUser(userData));
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Wrapper>
      <Form onSubmit={onSubmit}>
        <h2>Login User</h2>
        <Input
          className="form-control"
          name="email"
          value={email}
          type="email"
          onChange={onChange}
        />
        <Input
          className="form-control"
          name="password"
          value={password}
          type="password"
          onChange={onChange}
        />
        <Button type="submit" className="btn">
          Submit
        </Button>
        <div>
          Not Registered Yet? <Link to={"/register"}>Sign Up</Link>
        </div>
      </Form>
    </Wrapper>
  );
};

export default LoginScreen;
